export default __webpack_public_path__ + "static/media/Enduring Tasset.c1cde1e3.jpg";